import { render, staticRenderFns } from "./EbooksCoupons.vue?vue&type=template&id=6f9cc6ad&scoped=true&"
import script from "./EbooksCoupons.vue?vue&type=script&lang=js&"
export * from "./EbooksCoupons.vue?vue&type=script&lang=js&"
import style0 from "./EbooksCoupons.vue?vue&type=style&index=0&id=6f9cc6ad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f9cc6ad",
  null
  
)

export default component.exports